import { inject } from '@angular/core';
import {
	CanActivateChildFn,
	CanActivateFn,
	Router,
} from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from '../auth.service';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { combineLatest, firstValueFrom } from 'rxjs';

export const requireUserPermission = async (
	permission: string | string[]
) => {
	const userService = inject(UserService);
	const router = inject(Router);
	const authService = inject(AuthService);
	const auth0 = inject(Auth0Service);

	let currentUser = userService.userSig$();

	if (currentUser === null) {
		try {
			const [auth0User, accessToken] = await firstValueFrom(
				combineLatest([auth0.user$, auth0.getAccessTokenSilently()])
			);

			if (auth0User && accessToken) {
				authService.setTokenFromAuth0(auth0User, accessToken);
				currentUser = userService.userSig$();
			}
		} catch (error) {
			return router.parseUrl('pages/error/500');
		}
	}

	const hasPermission = userService.hasPermission(permission);

	if (!hasPermission) {
		return router.parseUrl('pages/error/401');
	}

	return true;
};

export const AdminGlobalGuard: CanActivateFn | CanActivateChildFn = async (
	route,
	state
) => requireUserPermission('admin:global');
